"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema = {
    schemaType: "object",
    properties: [
        {
            title: "プロジェクト名",
            propertyName: "projectName",
            schema: {
                schemaType: "text",
                required: true,
            },
        },
        {
            title: "ロゴ",
            propertyName: "logoUrl",
            schema: {
                schemaType: "image",
                maxHeight: 30,
            },
        },
    ],
};
exports.default = schema;
